import CONFIG from "@/assets/js/config.js";

export default Object.freeze({
    ...CONFIG,
    PARENT_REQUIRED: [
        'guardian1_name',
        'phone1',
        'address',
    ],
    STUDENT_REQUIRED: [
        'name',
        'dob',
        'gender',
        'religion',
        'class_id',
    ],
    PAYMENT_ITEM_TYPES: {
        2: "Default",
        3: "Enrollment",
    },
    PAYMENT_ITEM_TYPES_FILTER: {
        2: "Default",
        3: "Enrollment",
        4: "Late Fee",
        5: "Ferry Fee",
    },
    PAYMENT_ITEM_TYPES_Id: {
        tuitionFee: 1,
        default: 2,
        enrollment: 3,
        lateFee: 4,
        ferryFee: 5,
    },
    ALL_PAYMENT_ITEM_TYPES: {
        1: "Tuition Fee",
        2: "Default",
        3: "Enrollment",
        4: "Late Fee",
        5: "Ferry Fee",
    },
    PAYMENT_PLANS: [
        {
            id: 1,
            text: "One-Time",
        },
        {
            id: 2,
            text: "Termly",
        },
        {
            id: 3,
            text: "Monthly",
        },
    ],
    DISCOUNT_TYPE: {
        PERCENTAGE: 1,
        FIXED: 2,
    },
    PAYMENT_PLAN_IDS: {
        YEARLY: 1,
        TERMLY: 2,
        MONTHLY: 3,
    },
    PAYMNET_PLAN_LABELS: {
        1: "One-Time",
        2: "Termly",
        3: "Monthly",
    },
    TAX_RATE: Number(process.env.VUE_APP_TAXRATE ?? 0),

    DISCOUNT_TYPE_STATUS: {
        ACTIVE: 1,
        INACTIVE: 0
    },

    DISCOUNT_STATUS_TEXT: {
        1: "Active",
        0: "Inactive"
    },

    DISCOUNT_TYPES: {
        PERCENTAGE: 1,
        FIXED_AMOUNT: 2
    },

    DISCOUNT_TYPES_TEXT: {
        1: "Percentage",
        2: "Fixed Amount"
    },
  ROLE : {
    ID: {
      ADMIN: 1,
      STAFF: 2,
      ACCOUNTANT: 4,
      LIBRARY_ADMIN: 5,
      CLASS_MONITOR: 6,
      OTHER: 3,
      OFFICE_ADMIN: 7,
      PRINCIPAL: 8,
      ACADEMIC_COORDINATOR: 9,
      HR_OPERATOR: 10,
      SUPER_ADMIN: 11,
    },
    TXT: {
      1 : 'Admin',
      2 : 'Staff',
      4 : 'Accountant',
      5 : 'Library Admin',
      6 : 'Class Monitor',
      3 : 'Other',
      7 : 'Office Admin',
      8 : 'Principal',
      9 : 'Academic Coordinator',
      10 : 'HR Operator',
      11 : 'Super Admin',
    }
  },

  TEACHER_ROLE : {
    ID: {
      SUBJECT: 0,
      HOMEROOM: 1,
      ASSISTANT: 2
    },
    TXT: {
      0: 'Subject Teacher',
      1: 'Class Teacher',
      2: 'Assistant Teacher'
    }
  },

    EXAM_TYPE: [
        { id: "1", text: "Term Exam" },
        { id: "2", text: "Unit End Test" },
        { id: "3", text: "Project" },
    ],
    PAYMENT_STATUS : {
        STATUS_PARENT_ENROLL_REQUEST : 0,
        STATUS_APPROVED : 1,
        STATUS_DECLINED : 2,
        STATUS_ADMIN_REQUEST : 3,
        STATUS_DRAFT : 4,
        STATUS_PROCESSING : 5,
    },
    PAYMENT_STATUSES_OPTIONS : [
        { id: 0, text: "Request from Parent" },
        { id: 1, text: "Approve" },
        { id: 2, text: "Reject" },
        { id: 3, text: "Request to Parent" },
        { id: 4, text: "Draft" },
        { id: 5, text: "Processing" },
    ],
    TUITION_PAYMENT_STATUS : {
        STATUS_PROCESSING : 1,
        STATUS_DRAFT : 2,
        STATUS_DISPLAY : 3,
    },
    DIVISION: {
        1: 'School Readiness (2 years ~ 3 years)',
        2: 'Early Year 1 (3 years ~ 4 years)',
        3: 'Early Year 2 (4 years ~ 5 years)',
        4: 'Primary',
        5: 'Secondary',
        6: 'Advance'
    },
    REPORT_CARD_DISPLAY_STATUS : {
        1: 'Approve',
        2: 'Draft'
    },
    REPORT_CARD_DISPLAY_STATUS_KEYS : {
        APPROVE: 1,
        DRAFT: 2
    },
    REPORT_CARD_STATUS : {
        'M': 'Mastered',
        'A': 'Achieved',
        'P': 'Practicing'
    },

    PROFICIENCY_OPTIONS: {
        SP: 'Strong Proficiency',
        P: 'Proficient',
        D: 'Developing',
    },

    PAYMENT_HISTORY_STATUS_VAL: {
      PARENT_REQUEST: 0,
      APPROVED: 1,
      REJECTED: 2,
      ADMIN_REQUEST: 3,
    },

    PAYMENT_HISTORY_STATUS_TEXT: {
      0: 'Parent Request',
      1: 'Approve',
      2: 'Reject',
      3: 'Admin Request'
    },

    PARENT_PAYMENT_STATUS: {
      NOT_PAID: 0,
      PARTIAL_PAID: 1,
      FULLY_PAID: 2
    },

    PARENT_PAYMENT_STATUS_TEXT: {
      0: "Not Paid",
      1: "Partially Paid",
      2: "Fully Paid"
    },
 
    REFERRAL_STATUS: {
      PENDING: 1,
      PROCESSED: 2,
    },

    REFERRAL_STATUS_TEXT: {
      1: 'Pending',
      2: 'Processed',
    },

    /**
     * Student status values; must match backend Student model constants
     * (Student::STATUS_*).
     */
    STUDENT_STATUS: {
      ACTIVE: 0,
      INACTIVE_BY_SYSTEM: 1,
      INACTIVE_BY_PRIME: 2,
      GRADUATED: 3,
      FINANCIAL_SUSPENDED: 4,
      MISCONDUCT_SUSPENDED: 5,
      DROPPED_FOR_NONPAYMENT: 6,
      EXPELLED: 7,
    },

    STUDENT_STATUS_TEXT: {
      0: 'Active',
      1: 'Inactive By System',
      2: 'Inactive By Prime',
      3: 'Graduated',
      4: 'Financial Suspended',
      5: 'Misconduct Suspended',
      6: 'Dropped for Nonpayment',
      7: 'Expelled (Disciplinary)',
    },

    TRANSACTION_TYPE: {
      INCOME: 1,
      EXPENSE: 2,
      ASSET: 3,
      INVESTMENT: 4,
    },

    /** m_holiday.category_id - must match backend custom.constants.HOLIDAY_CATEGORIES */
    HOLIDAY_EVENT_CATEGORY_OPTIONS: [
        { id: 1, label: "PRIME Holidays", color_code: "#04923f" },
        { id: 2, label: "Primary Exam Week", color_code: "#ac04a7" },
        { id: 3, label: "PRIME School Activities", color_code: "#c39049" },
        { id: 4, label: "PRIME Parent-Teacher Meeting (PTM)", color_code: "#0dbbcf" },
        { id: 5, label: "PRIME Teachers PD Day", color_code: "#9ba0a7" },
        { id: 6, label: "PRIME Year End", color_code: "#ab0505" },
        { id: 7, label: "PRIME Events", color_code: "#fff200" },
    ],

    /** m_holiday.type (optional) */
    HOLIDAY_TYPE_OPTIONS: {
        1: "Holiday",
        2: "Student Holiday",
        3: "Event",
    },

    UPDATE_SCOPE: {
        APPLY_TODAY_ONLY: 1,
        APPLY_TODAY_AND_FUTURE: 2,
    },

    FINANCIAL_SUMMARY: {
        DEFAULT_PREVIOUS_YEAR: 5,
        MAX_YEAR: 10,
    },

    POSITION_TYPE: {
        STAFF: 1,
        TEACHER: 2,
    },

    POSITION_TYPE_TEXT: {
        1: 'Staff',
        2: 'Teacher',
    },
});
